import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ru from "./locales/ru.json";
import en from "./locales/en.json";
import cn from "./locales/cn.json";
import es from "./locales/es.json";
import de from "./locales/de.json";

i18n.use(initReactI18next).init({
    resources: {
        en: { translation: en },
        ru: { translation: ru },
        cn: { translation: cn },
        es: { translation: es },
        de: { translation: de },
    },
    lng: window.location.pathname.split("/")[1] || "en",
    // lng: 'cn',
    // fallbackLng: 'ru',
    fallbackLng: "en",
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
